// App.tsx
import React, { useEffect, useState, Suspense } from "react";
import "./App.css";
import Header from "./components/Header";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CustomCursor from "./components/CustomCursor";
import VantaBirdsBackground from "./components/VantaBirdsBackground";

const Home = React.lazy(() => import("./components/Home"));
const Skills = React.lazy(() => import("./components/Skills"));
const Experience = React.lazy(() => import("./components/Experience"));
const Projects = React.lazy(() => import("./components/Projects"));
const About = React.lazy(() => import("./components/About"));
const Contact = React.lazy(() => import("./components/Contact"));

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <VantaBirdsBackground />
      <div className="AppContent">
        { }
        <CustomCursor />
        {loading ? (
          <div className="skeleton-container">
          </div>
        ) : (
          <Suspense fallback>
            <Header />
            <Home />
            <Skills />
            <Experience />
            <Projects />
            <About />
            <Contact />
          </Suspense>
        )}
      </div>
    </>
  );
};

export default App;
